import { Link } from "react-router-dom";

function Menu() {
    return (
        <nav className="menu">
            <ul>
                <li>
                    <Link to="/">Accueil</Link>
                </li>
                <li style={{ display: "none" }}>
                    <Link to="/galerie">Galerie</Link>
                </li>
                <li>
                    <Link to="/contact">Obtenir un devis</Link>
                </li>
            </ul>
        </nav>
    )
}

export default Menu;